import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import { persistor, store } from "./redux/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { AuthContextProvider } from "./context/AuthContext";
import TagManager from "react-gtm-module";
import { BrowserRouter } from "react-router-dom";

// Initialize GTM
const tagManagerArgs = {
  gtmId: "GTM-NB7G6PDS", // <-- replace with your GTM ID
};
TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthContextProvider>
      <Provider store={store}>
        <PersistGate loading={"loading"} persistor={persistor}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </AuthContextProvider>
  </React.StrictMode>
);
